import React from 'react';
import { LancamentoPerdasProvider, useLancamentoPerdas } from '../../../contexts/MP/LancamentoPerdasContext';
import ModalLancamentoPerdas from './ModalLancamentoPerdas';

// Hook para integrar o lançamento de perdas com o botão Finalizar
export const useLancamentoPerdasFinalizar = () => {
    const context = useLancamentoPerdas();

    const finalizarComConfirmacao = (pecas, amostra, defeitos, onFinalizar) => {
        if (!context || (!context.abrirConfirmacao && !context.abrirModal)) {
            // Se não há contexto, executa finalização normal
            onFinalizar();
            return;
        }

        // Mapear defeitos para cada peça
        const pecasArray = Array.isArray(pecas) ? pecas : [];
        const defeitosObj = defeitos || {};

        const pecasComDefeitos = pecasArray.map(peca => {
            let defeitosPeca = [];

            // Se defeitos é um objeto (durante análise)
            if (defeitosObj && typeof defeitosObj === 'object' && !Array.isArray(defeitosObj)) {
                defeitosPeca = defeitosObj[peca.peca] || [];
            }
            // Se defeitos é um array (durante finalização)
            else if (Array.isArray(defeitosObj)) {
                defeitosPeca = defeitosObj.filter(defeito => defeito.peca === peca.peca) || [];
            }

            return {
                ...peca,
                defeitos: defeitosPeca
            };
        });

        // Abrir confirmação antes de mostrar o modal de perdas
        context.abrirConfirmacao(pecasComDefeitos, amostra, onFinalizar);
    };

    return { finalizarComConfirmacao };
};

//revisao com lançamento de perdas
const RevisaoComLancamentoPerdas = ({ children, modoBatch = false }) => {
    return (
        <LancamentoPerdasProvider modoBatch={modoBatch}>
            {children}
            <ModalLancamentoPerdas />
        </LancamentoPerdasProvider>
    );
};

export default RevisaoComLancamentoPerdas;
